import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSetAtom } from 'jotai';
import { useAtomCallback } from 'jotai/utils';

import type { ApiDashboardAggregate } from 'src/types/dashboard';
import { chatbotPrimeTexts } from 'src/components/chatbot/atoms';

const useChatbotData = (
  comparisonAggregate?: ApiDashboardAggregate,
  focalAggregate?: ApiDashboardAggregate,
) => {
  const { t } = useTranslation('dashboard');
  const setChatbotData = useSetAtom(chatbotPrimeTexts('preChat'));
  // get the current state without subscribing to it to prevent an infinite rerender
  const chatbotData = useAtomCallback(
    useCallback((get) => get(chatbotPrimeTexts('preChat')), []),
  );

  useEffect(() => {
    let primeText = chatbotData().doughnutWidget?.primeText || '';
    if (focalAggregate && !primeText.includes(focalAggregate.label)) {
      const createChatbotPrimeData = () => {
        let primeTextLine =
          `${focalAggregate.label}: ${focalAggregate.ptop2}, ` +
          `${t('Labels.DiffToLastYear')}: ${focalAggregate.ptop2_yoyDiff}`;

        if (comparisonAggregate) {
          primeTextLine = `${primeTextLine}, Overall ${comparisonAggregate.ptop2}`;
        }
        return primeTextLine;
      };
      primeText = primeText
        ? `${primeText}; ${createChatbotPrimeData()}`
        : createChatbotPrimeData();
    }

    setChatbotData({
      doughnutWidget: { primeText, primeQuestion: "What's the situation?" },
    });
  }, [focalAggregate]);
};

export default useChatbotData;
